var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "visitors" } }, [
    _c(
      "div",
      { staticClass: "filter-sidebar", class: [_vm.dropdown && "closed"] },
      [
        _c("div", { staticClass: "filter-sidebar-content" }, [
          _c("div", { staticClass: "filter-sidebar-group" }, [
            _c("div", { staticClass: "filter-sidebar-group-title" }, [
              _vm._v("Favoriler"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "filter-sidebar-group-content" }, [
              _c(
                "div",
                { staticClass: "favorite-items" },
                _vm._l(
                  _vm.favFilters["page.contact-list"] || [],
                  function (fav) {
                    return _c(
                      "div",
                      {
                        key: fav._id,
                        staticClass: "favorite-item",
                        class: {
                          selected:
                            _vm.selectedFavFilter &&
                            _vm.selectedFavFilter._id === fav._id,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "favorite-item-content",
                            on: {
                              click: function ($event) {
                                return _vm.selectFavFilter(fav)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "favorite-item-icon material-icons",
                              },
                              [_vm._v("star")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "favorite-item-text" }, [
                              _vm._v(_vm._s(fav.name)),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "SaveFilterModal",
                          {
                            attrs: { value: fav.name },
                            on: {
                              save: function ($event) {
                                return _vm.saveFilter($event, fav)
                              },
                              delete: function ($event) {
                                return _vm.deleteFavFilter(fav.key, fav._id)
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "content",
                                  fn: function () {
                                    return [_vm._v(" sa")]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "favorite-item-edit material-icons",
                                },
                                [_vm._v("edit")]
                              ),
                            ],
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  }
                ),
                0
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "filter-sidebar-group group-filters" }, [
            _c("div", { staticClass: "filter-sidebar-group-title" }, [
              _vm._v("Filters"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "filter-sidebar-group-content" },
              _vm._l(_vm.filteredItems, function (filter, index) {
                return _c(
                  "div",
                  { staticClass: "item" },
                  [
                    _c("MiniFilterPreview", {
                      attrs: { filter: filter },
                      on: {
                        deleteFilter: function ($event) {
                          return _vm.deleteFilter(index)
                        },
                      },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "filter-sidebar-footer" }, [
          _c(
            "div",
            { staticClass: "filter-sidebar-control" },
            [
              _c("Filters", {
                attrs: {
                  data: _vm.filters,
                  active: _vm.activeFilter,
                  defaultFilters: _vm.filteredItems,
                  align: "top",
                  "view-in-side": false,
                },
                on: {
                  changeActive: function (val) {
                    return (_vm.activeFilter = val)
                  },
                  filtered: function (items) {
                    return (_vm.filteredItems = items)
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "content",
                    fn: function () {
                      return [
                        _c("div", { staticClass: "control-button" }, [
                          _c("div", { staticClass: "material-icons" }, [
                            _vm._v("filter_alt"),
                          ]),
                          _vm._v(" "),
                          _c("div", [_vm._v("Add Filter")]),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _vm._v(" "),
              _vm.filteredItems.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "control-button",
                      on: { click: _vm.clearFilters },
                    },
                    [
                      _c("div", { staticClass: "material-icons" }, [
                        _vm._v("filter_alt_off"),
                      ]),
                      _vm._v(" "),
                      _c("div", [_vm._v("Clear Filter")]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "filter-sidebar-collapse",
              on: {
                click: function ($event) {
                  _vm.dropdown = !_vm.dropdown
                },
              },
            },
            [
              _c("div", { staticClass: "information-text" }, [
                _vm._v("Show/Hide"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "material-icons",
                  staticStyle: { cursor: "pointer" },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.dropdown
                          ? "keyboard_double_arrow_right"
                          : "keyboard_double_arrow_left"
                      ) +
                      "\n                "
                  ),
                ]
              ),
            ]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "visitors-content" }, [
      _c(
        "div",
        [
          _c("div", { staticClass: "tool-head" }, [
            _c(
              "div",
              { staticClass: "left-side" },
              [
                _c(
                  "div",
                  { staticClass: "save-filter-bar" },
                  [
                    _c("div", { staticClass: "filter-title" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.selectedFavFilter
                              ? _vm.selectedFavFilter.name
                              : "Contact Search"
                          ) +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.selectedFavFilter
                      ? _c(
                          "SaveFilterModal",
                          {
                            attrs: { value: _vm.selectedFavFilter.name },
                            on: {
                              save: function ($event) {
                                return _vm.saveFilter(
                                  $event,
                                  _vm.selectedFavFilter
                                )
                              },
                              delete: function ($event) {
                                return _vm.deleteFavFilter(
                                  _vm.selectedFavFilter.key,
                                  _vm.selectedFavFilter._id
                                )
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "content",
                                  fn: function () {
                                    return [_vm._v(" sa")]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              566497030
                            ),
                          },
                          [
                            [
                              _c("a-icon", {
                                attrs: { type: "star", theme: "filled" },
                              }),
                            ],
                          ],
                          2
                        )
                      : _c(
                          "SaveFilterModal",
                          {
                            on: { save: _vm.saveFilter },
                            scopedSlots: _vm._u([
                              {
                                key: "content",
                                fn: function () {
                                  return [_vm._v(" sa")]
                                },
                                proxy: true,
                              },
                            ]),
                          },
                          [[_c("a-icon", { attrs: { type: "star" } })]],
                          2
                        ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("a-input-search", {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: _vm.$t("message.typeSTToSearch") },
                  on: { change: _vm.onSearch },
                  model: {
                    value: _vm.searchText,
                    callback: function ($$v) {
                      _vm.searchText = $$v
                    },
                    expression: "searchText",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "right-side" },
              [
                _c(
                  "a-popover",
                  { attrs: { placement: "bottomRight", trigger: "click" } },
                  [
                    _c(
                      "template",
                      { slot: "content" },
                      _vm._l(_vm.allColumns, function (col) {
                        return _c(
                          "div",
                          [
                            _c(
                              "a-checkbox",
                              {
                                on: {
                                  change: function ($event) {
                                    return _vm.onChangeCol(col, $event)
                                  },
                                },
                                model: {
                                  value: col.enabled,
                                  callback: function ($$v) {
                                    _vm.$set(col, "enabled", $$v)
                                  },
                                  expression: "col.enabled",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(col.title) +
                                    "\n                                "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("a-button", { staticClass: "flex-center-center" }, [
                      _c("div", { staticClass: "material-icons" }, [
                        _vm._v("app_registration"),
                      ]),
                    ]),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "flex-center-center",
                    on: { click: _vm.paddingReset },
                  },
                  [
                    _c("div", { staticClass: "material-icons" }, [
                      _vm._v(
                        _vm._s(
                          _vm.paddingReseted ? "fullscreen" : "fullscreen_exit"
                        )
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-popover",
                  {
                    attrs: {
                      placement: "bottomRight",
                      trigger: "click",
                      overlayClassName: "download-popover",
                    },
                  },
                  [
                    _c("template", { slot: "content" }, [
                      _c("div", { staticClass: "download-options" }, [
                        _c(
                          "div",
                          {
                            staticClass: "export-csv-visitor-page",
                            on: { click: _vm.exportToCSV },
                          },
                          [
                            _c("div", { staticClass: "material-icons" }, [
                              _vm._v("description"),
                            ]),
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.$t("message.exportToCSV")) +
                                "\n                                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "export-csv-visitor-page",
                            class: { disabled: _vm.visitorDownloding },
                            on: { click: _vm.downloadAll },
                          },
                          [
                            _c("div", { staticClass: "material-icons" }, [
                              _vm._v("download"),
                            ]),
                            _vm._v(
                              "\n                                    Tümünü İndir (XLSX)\n                                "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        staticClass: "flex-center-center",
                        staticStyle: { "margin-right": "3px" },
                      },
                      [
                        _c("div", { staticClass: "material-icons" }, [
                          _vm._v("more_horiz"),
                        ]),
                      ]
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("supsis-table", {
            class: { "visitor-table": true, expended: _vm.paddingReseted },
            attrs: {
              id: "supsis-contacts-list",
              columns: _vm.columns,
              rows: _vm.visitors,
              options: _vm.tableOptions,
              "bottom-pagination": true,
              "pagination-cursor": _vm.paginationCursor,
            },
            on: { "cursor-changed": _vm.paginationCursorChanged },
            scopedSlots: _vm._u([
              {
                key: "emptyData",
                fn: function () {
                  return [
                    _c("EmptyFilterResult", {
                      attrs: { "clear-filters": _vm.clearFilters },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }